import { Typography } from "@pondigitalsolutions/pon-component-library";
import { ShareButton } from "@components/ShareButton";
import { buildBannerImageUrl } from "@utils/image-utils";
import { useCheckSmallScreen } from "@hooks/useCheckSmallScreen";
import { BannerProps } from "../types/BannerTypes";

export const Banner = ({ title, data }: BannerProps) => {
  const isSmallScreenSize = useCheckSmallScreen();
  const imageUrl = buildBannerImageUrl(
    data?.bannerContent?.image,
    isSmallScreenSize
  );

  return (
    <div
      className="relative flex h-80 items-end bg-gradient-to-t from-secondary-700/80 from-0% via-secondary-700/70 via-25% to-transparent to-50% bg-cover bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(var(--tw-gradient-stops)), url('${imageUrl}')`,
      }}
      data-testid="banner"
    >
      <div className="flex w-full items-end justify-between gap-4 py-8 max-xl:mx-auto max-xl:max-w-2xl max-md:px-7 xl:px-60">
        <div className="flex flex-col gap-2">
          <Typography
            size="sm"
            className="leading-[130%] font-semibold text-white"
          >
            {data?.bannerContent?.subtitle}
          </Typography>
          <Typography
            size="xl"
            as="h1"
            className="leading-[120%] font-semibold text-white lg:text-3xl"
          >
            {title}
          </Typography>
        </div>
        <ShareButton variant="soft" />
      </div>
    </div>
  );
};
